import {BASE_MAPS_URL} from './constants';

export function getMapUrlForCoordinate(long: string, lat: string, zoom = 16) {
  const ll = `${long},${lat}`;
  return `${BASE_MAPS_URL}/?ll=${ll}&z=${zoom}&pt=${ll}~Точка`;
}

export function getMapUrlForText(mapAddress: string) {
  return `${BASE_MAPS_URL}/?text=${encodeURIComponent(mapAddress)}`;
}
